"use strict";

exports.__esModule = true;
var _Timeline = _interopRequireDefault(require("./Timeline"));
exports.default = _Timeline.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}